import React from 'react'
import Box from '@cloudscape-design/components-themed/box'

// https://cloudscape.design/components/box
export function RadBox ({ ...rest }) {
  return (
    <Box {...rest} />
  )
}
